import {
  Alert,
  Box,
  Button, Skeleton, Typography
} from '@mui/material';
import useUser from '../../../../hooks/useUser';
import ProductHierarchySelect from '../../../../shared/components/ProductHierarchySelect/ProductHierarchySelect';
import TenantField from '../../../../interfaces/TenantField';
import { isEmpty } from 'lodash';
import useHierarchyRFMConfig from '../../hooks/useHierarchyRFMConfig';
import DeleteDialog from '../../../../shared/components/DeleteDialog/DeleteDialog';
import { useState } from 'react';

const HierarchyRFMConfigHeader = () => {
  const { selectedBusiness } = useUser();
  const {
    hierarchyRFMConfig,
    hierarchyRFMConfigLoading,
    hierarchyRFMConfigError,

    selectedHierarchy,
    setSelectedHierarchy,

    deleteConfig,
  } = useHierarchyRFMConfig();

  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

  if (hierarchyRFMConfigLoading)
    return (
      <Skeleton
        variant='rounded'
        width={'100%'}
        height={40}
      />
    );

  if (hierarchyRFMConfigError) return <Alert>{hierarchyRFMConfigError}</Alert>;

  return (
    <Box>
      {isEmpty(hierarchyRFMConfig) ? (
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography variant='h5'>Select Product Hierarchy</Typography>
          <ProductHierarchySelect
            multiple={false}
            value={selectedHierarchy}
            onChange={(newValue: TenantField) => setSelectedHierarchy(newValue)}
            options={selectedBusiness.productHierarchy}
            sx={{
              width: '12rem',
              backgroundColor: 'white',
            }}
            size='small'
          />
        </Box>
      ) : (
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography variant='h5'>{selectedHierarchy?.label}</Typography>
          <Button onClick={() => setShowDeleteDialog(true)} variant='outlined'>
            Delete
          </Button>
          <DeleteDialog
            open={showDeleteDialog}
            onDelete={deleteConfig}
            onClose={() => setShowDeleteDialog(false)}
            content={
              <Typography>
                This will delete the entire configuration for{' '}
                <Typography fontWeight={600} component='span'>
                  {selectedHierarchy?.label}
                </Typography>
              </Typography>
            }
            deleteButtonText='Yes, Delete'
            title='Confirm Deletion'
          />
        </Box>
      )}
    </Box>
  );
};

export default HierarchyRFMConfigHeader;
